export class ActiveCampaign {
  private actid: string
  private active: boolean

  constructor(actid: string, active?: boolean) {
    this.actid = actid
    this.active = active!
  }

  public pageView() {
    return new Promise<void>((resolve, reject) => {
      const trackcmp = document.createElement('script')

      trackcmp.onload = () => {
        resolve()
      }

      trackcmp.onerror = () => {
        reject()
      }

      trackcmp.async = true
      trackcmp.type = 'text/javascript'
      trackcmp.textContent = `(function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
      vgo('setAccount', '${this.actid}');
      vgo('setTrackByDefault', true);
      vgo('process');`
      const trackcmpS = document.getElementsByTagName('script')
      if (this.active) {
        if (trackcmpS.length && trackcmpS[0].parentNode !== null) {
          ;(trackcmpS[0].parentNode as Node).appendChild(trackcmp)
        } else {
          document.head.appendChild(trackcmp)
        }
        resolve()
      } else {
        resolve()
      }
    })
  }
}
